import type { NotificationChannels } from './types';

/**
 * Empty dict {} from API means "use these defaults" (backward-compat).
 * An explicit empty list [] for a type means "muted" and is intentional —
 * do NOT fall back to defaults for [].
 */
export const DEFAULT_NOTIFICATION_CHANNELS: NotificationChannels = {
  proposals: ['push'],
  digests: ['email'],
};
